import { radius } from '../components/primitives/shape'
import type { ActivityItem, Agent } from '../api/types'
import { clockOf, displayName } from './format'

/** What has asked for the reader, in the room's place until they go back to it. */
export function ActivityView({ activity, roster, compact, onOpenItem, onBack }: {
  activity: ActivityItem[]
  /** Where a sender's nickname is looked up; a sender it does not hold shows as its handle. */
  roster: Pick<Agent, 'name' | 'nickname'>[]
  /** On a phone it is the screen, under the notch and over the bottom bar. */
  compact: boolean
  onOpenItem: (item: ActivityItem) => void
  onBack: () => void
}) {
  return (
    <section
      aria-label="Activity"
      style={{
        flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden',
        ...(compact
          ? { paddingTop: 'var(--safe-top)', paddingBottom: 'var(--compact-nav-space)' }
          : { background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: radius.lg }),
      }}
    >
      <header style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 20px', borderBottom: '1px solid var(--border)', flex: 'none' }}>
        <button
          type="button"
          onClick={onBack}
          aria-label="Back to the room"
          className="sp-tap"
          style={{ width: 26, height: 26, borderRadius: radius.xs, background: 'var(--panel-strong)', cursor: 'pointer', flex: 'none' }}
        >
          ←
        </button>
        <h2 style={{ margin: 0, font: '600 16px var(--font-interface)' }}>Activity</h2>
      </header>
      <div
        style={{
          flex: 1, minHeight: 0, overflowY: 'auto', padding: '14px max(16px, calc((100% - 860px) / 2)) 18px',
          overscrollBehaviorY: 'contain', WebkitOverflowScrolling: 'touch',
        }}
      >
        {activity.map((item) => (
          <button
            type="button"
            key={item.message_id}
            onClick={() => onOpenItem(item)}
            style={{ display: 'block', width: '100%', textAlign: 'left', padding: '12px 10px', borderRadius: radius.md, background: 'var(--panel)', marginBottom: 8, cursor: 'pointer' }}
          >
            <span style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 5 }}>
              <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase', color: item.reason === 'mention' ? 'var(--accent)' : 'var(--text-dim)' }}>
                {item.reason}
              </span>
              <span style={{ font: '400 10px var(--font-machine)', color: 'var(--text-faint)' }}>{item.repository_key}</span>
              <span style={{ font: '400 10px var(--font-machine)', color: 'var(--text-faint)', marginLeft: 'auto' }}>
                {clockOf(item.posted_at)}
              </span>
            </span>
            <span style={{ display: 'block', fontSize: 12.5, fontWeight: 700, marginBottom: 3 }}>
              {displayName(item.sender, roster.find((agent) => agent.name === item.sender)?.nickname)}
            </span>
            <span className="sp-said" style={{ display: 'block', fontSize: 12.5, lineHeight: 1.5, color: 'var(--text-dim)' }}>{item.preview}</span>
          </button>
        ))}
        {!activity.length && (
          <p style={{ fontFamily: 'var(--font-human)', fontStyle: 'italic', fontSize: 13.5, color: 'var(--text-faint)', padding: '20px 4px' }}>
            Nothing has asked for you.
          </p>
        )}
      </div>
    </section>
  )
}
